import { EventEmitter, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment';
import { FormBuilder } from "@angular/forms";
import { NgbDateAdapter, NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { CapacitacionService } from '../../services/capacitacion.service';
import { ComboBuilderService } from '../../services/combo-builder.service';
import { ValidationService } from '../../services/validation.service';
import { EvidenciaService } from '../../services/evidencia.service';
import { EJECUTOR_OTHERS_ID, PLANIFICADA_ID, REFORZAMIENTO_ID, MONTHS, CERRADA_STATE, APROBADA_STATE, PENDIENTE_STATE, PENDIENTE_CON_RETRASO_STATE } from '../../utils/constants';
import { ToastrService } from 'ngx-toastr';
import { ZoneService } from 'src/app/services/zone.service';
import { LoginService } from 'src/app/services/login.service';
export class CustomAdapter extends NgbDateAdapter {
    constructor() {
        super(...arguments);
        this.DELIMITER = '-';
    }
    fromModel(value) {
        if (value) {
            const date = value.split(this.DELIMITER);
            return {
                day: parseInt(date[0], 10),
                month: parseInt(date[1], 10),
                year: parseInt(date[2], 10)
            };
        }
        return null;
    }
    toModel(date) {
        return date ? date.day + this.DELIMITER + date.month + this.DELIMITER + date.year : null;
    }
}
export class CustomDateParserFormatter extends NgbDateParserFormatter {
    constructor() {
        super(...arguments);
        this.DELIMITER = '/';
    }
    parse(value) {
        if (value) {
            const date = value.split(this.DELIMITER);
            return {
                day: parseInt(date[0], 10),
                month: parseInt(date[1], 10),
                year: parseInt(date[2], 10)
            };
        }
        return null;
    }
    format(date) {
        return date ? date.day + this.DELIMITER + date.month + this.DELIMITER + date.year : '';
    }
}
export class CapacitacionModalComponent {
    constructor(modalService, capacitacionService, comboBuilderService, validationService, evidenciaService, fb, toastr, zoneService, loginService) {
        this.modalService = modalService;
        this.capacitacionService = capacitacionService;
        this.comboBuilderService = comboBuilderService;
        this.validationService = validationService;
        this.evidenciaService = evidenciaService;
        this.fb = fb;
        this.toastr = toastr;
        this.zoneService = zoneService;
        this.loginService = loginService;
        this.save = new EventEmitter();
        this.accept = new EventEmitter();
        this.reject = new EventEmitter();
        this.enfoques = [];
        this.categoriesWithFocos = [];
        this.zonas = [];
        this.ejecutoresWithRelatores = [];
        this.capacitacion = {
            capacitacionId: null,
            capacitacionTypeId: 1,
            name: null,
            categoryId: -1,
            categoryDescription: '',
            focoId: -1,
            focoDescription: '',
            enfoqueId: -1,
            enfoqueDescription: '',
            zone: "-1",
            observation: null,
            ejecutorId: -1,
            ejecutorDescription: '',
            ejecutorOthers: null,
            relatorId: -1,
            relatorDescription: '',
            day: '',
            month: '-1',
            year: '2020',
            estimatedTheoryHours: null,
            estimatedPracticeHours: null,
            estimatedHours: 0,
            realTheoryHours: null,
            realPracticeHours: null,
            realHours: 0,
            estimatedAssistants: null,
            realAssistants: null,
            realExecutionDate: null,
            stateId: null,
            stateShortDescription: '',
            creationDate: null,
            userId: sessionStorage.getItem('userid'),
            fecha: '',
            isClosed: true,
            estimatedTrainingDate: '',
            statusCapacitacionLabel: ''
        };
        this.errors = {
            name: false,
            categoryId: false,
            focoId: false,
            enfoqueId: false,
            ejecutorId: false,
            zoneId: false,
            ejecutorOthers: false,
            relatorId: false,
            month: false,
            year: false,
            estimatedTheoryHours: false,
            estimatedPracticeHours: false,
            estimatedHours: false,
            realTheoryHours: false,
            realPracticeHours: false,
            realHours: false,
            fechaCapacitacion: false,
            estimatedAssistants: false,
            realAssistants: false,
            realExecutionDate: false,
            observation: false,
            realEvidence: false
        };
        this.flags = {
            ejecutor: false,
            relator: false,
            duracionTeorica: false,
            duracionPractica: false,
            duracionReal: false,
            fechaEjecucionReal: false,
            Evidencia: false,
            AsignacionParticipantes: false,
            Guardar: false
        };
        this.isRead = false;
        this.showBar = false;
        this.isReadOnEdit = false;
        this.focoCombo = [];
        this.relatorCombo = [];
        this.monthsCombo = [];
        this.ejecutorOthersId = EJECUTOR_OTHERS_ID;
        this.showErrorMessage = false;
        this.showEvidenceMessage = false;
        this.confirmationModalHasComment = false;
        this.confirmationModalHasOptions = false;
        this.confirmationModalisCommentObligatory = false;
        this.workersIdSelected = [];
        this.workersSelected = [];
        this.workersColumns = [
            'Rut Trabajador',
            'Nombre',
            'Apellido Paterno',
            'Apellido Materno'
        ];
        this.workersRows = [];
        this.year = new Date().getFullYear();
        this.yearMax = this.year + 4;
        this.loading = false;
        this.evidences = [];
        this.fileData = null;
        this.error = false;
        this.errorMessage = "";
        this.listClass = false;
        this.flagZona = false;
        this.uuid = "";
        this.closeCapacitacionStatus = false;
        this.fileUpload = false;
        this.messageFieldUpload = "";
        this.arrayTypeFile = [];
        this.statusCloseCapacitacion = ['Cerrada', 'Cerrada con Retraso'];
        this.form = this.fb.group({
            evidenceFile: [null]
        });
    }
    ngOnInit() {
        console.log('Cargadando Capacitacion');
        console.log(this.capacitacion);
        if (this.mode == 'reforzamiento') {
            this.capacitacion.statusCapacitacionLabel = 'Abierta';
        }
        this.loginService.obtenerPermisosMenu('planificacion')
            .then((response) => {
            console.log(response);
            this.rolid = response.data.rolId;
        });
        this.isRead = this.mode === 'read';
        console.log('Capacitacion de Entrada');
        console.log(this.capacitacion);
        if (this.mode == 'planificar' || this.mode == 'reforzamiento')
            this.capacitacion.capacitacionTypeId =
                this.mode === 'planificar' ? PLANIFICADA_ID : REFORZAMIENTO_ID;
        if (this.mode !== 'edit' && this.mode !== 'read' && this.rolid != 1) {
            this.capacitacion.capacitacionTypeId = this.mode === 'planificar' ? PLANIFICADA_ID : REFORZAMIENTO_ID;
            //Solucion momentanea a problema de año de planificación, toma el valor del año inicial configurado
            const loginData = JSON.parse(sessionStorage.getItem('loginData'));
            const fechaPlanificacion = loginData.configurationTableEntity.filter((x) => x.codigo == "FECHA_PLAN");
            if (!(fechaPlanificacion[0] === undefined)) {
                const fechaInicio = new Date(fechaPlanificacion[0].inicioDate);
                this.capacitacion.year = this.mode === 'planificar' ? ((fechaInicio.getFullYear()) + 1).toString() : moment().year().toString();
            }
            // lo que está en el else se debe dejar una vez desarrollada solucion a configuración año de planificacion
            else
                this.capacitacion.year = this.mode === 'planificar' ? (moment().year() + 1).toString() : moment().year().toString();
        }
        if (this.capacitacion.categoryId !== -1) {
            this.focoCombo = this.getFocos(this.capacitacion.categoryId);
            console.log('Focos Combo');
            console.log(this.focoCombo);
        }
        if (this.capacitacion.ejecutorId !== -1) {
            this.relatorCombo = this.getRelatores(this.capacitacion.ejecutorId);
        }
        // this.capacitacion.realHours = 0;
        this.monthsCombo = this.comboBuilderService.buildMonthsCombo();
        this.workersRows = this.workersSelected.map(worker => this.buildWokerRow(worker));
        this.capacitacion.realAssistants = this.workersRows.length;
        if (this.capacitacion.capacitacionTypeId === REFORZAMIENTO_ID)
            this.capacitacion.estimatedAssistants = 0;
        this.canEditOnApprove();
        //this.showBar = this.showAcceptRejectBar(this.capacitacion);
        // if(this.capacitacion.creationDate){
        // 	let fecha = new Date(this.capacitacion.creationDate)
        // 	this.capacitacion.creationDate = moment(fecha).format('DD-MM-YYYY')
        // }
        if (this.capacitacion.realExecutionDate) {
            console.log('ANTES DEL CAMBIO');
            console.log(this.capacitacion.realExecutionDate);
            this.capacitacion.realExecutionDate = Array.isArray(this.capacitacion.realExecutionDate) ? this.capacitacion.realExecutionDate.join('-') : this.capacitacion.realExecutionDate;
            this.capacitacion.realExecutionDate = moment(this.capacitacion.realExecutionDate).format('DD-MM-YYYY');
            console.log('DESPUES DEL CAMBIO');
            console.log(this.capacitacion.realExecutionDate);
        }
        console.log(moment(this.capacitacion.realExecutionDate).format('DD-MM-YYYY'));
        console.log(moment(this.capacitacion.creationDate));
        //Formateando fecha de capacitacion, ya que actualmente toma la fecha de creación como fecha de capacitacion lo cual es demasiado incorrecto
        let fechaCapacitacion = moment(this.capacitacion.day + '-' + this.capacitacion.month + '-' + this.capacitacion.year, 'DD-MM-YYYY').format('DD-MM-YYYY');
        console.log('FECHA CAPACITACION');
        console.log(fechaCapacitacion);
        this.capacitacion.estimatedTrainingDate = fechaCapacitacion;
        if (this.isRead) {
            this.capacitacion.realExecutionDate = moment(this.capacitacion.realExecutionDate, 'DD-MM-YYYY').format('DD-MM-YYYY');
        }
        if (this.capacitacion.realExecutionDate == 'Invalid date') {
            this.capacitacion.realExecutionDate = '';
        }
        this.fetchEvidencia();
        console.log(this.capacitacion);
        console.log('Capacitacion en modo');
        console.log(this.mode);
        this.capacitacionService.getTipoArchivosActivos()
            .then((response) => {
            if (response.data != null && response.data.length > 0) {
                response.data.forEach(element => {
                    this.arrayTypeFile.push(element.valor);
                });
                console.log('Tipo de archivos');
                console.log(this.arrayTypeFile);
            }
        }).catch((error) => {
            console.log('Ha ocurrido un error');
            console.log(error);
        });
    }
    getLabel(value, defaultValue) {
        return value ? value.toString() : defaultValue;
    }
    // isIconActive(icon: string, capacitacion: any): boolean {
    // return this.validationService.isActiveIcon(icon, capacitacion);
    // }
    isIconActiveSend(capacitacion) {
        return this.validationService.isActiveIconSend(capacitacion, String(this.rolid));
    }
    isIconActiveDelete(capacitacion) {
        return this.validationService.isActiveIconDelete(capacitacion, String(this.rolid));
    }
    isIconActiveEdit(capacitacion) {
        return this.validationService.isActiveIconEdit(capacitacion);
    }
    isIconActiveAccept(capacitacion) {
        //return this.validationService.isActiveIconAccept(capacitacion);
        return (this.validationService.canAcceptOrReject(capacitacion, String(this.rolid)) || this.validationService.canClose(capacitacion, String(this.rolid)));
    }
    isIconActiveReject(capacitacion) {
        return this.validationService.isActiveIconReject(capacitacion, String(this.rolid));
    }
    showAcceptRejectBar(capacitacion) {
        return this.isIconActiveReject(capacitacion) || this.isIconActiveAccept(capacitacion);
    }
    canAssignWorkers() {
        return (!this.isRead && this.validationService.canAssignWorkers(this.capacitacion)) || this.mode === 'edit';
    }
    canEditCapacitacion() {
        //return !this.isReadOnEdit && this.validationService.canEdit(this.capacitacion);
        return this.validationService.canEdit(this.capacitacion);
    }
    onAcceptCapacitacion(isSend = false) {
        if (isSend) {
            this.onSave(true);
        }
        else {
            this.capacitacionService.accept(this.capacitacion.capacitacionId, sessionStorage.getItem('userid'), "0", this.actionComment)
                .then(response => {
                this.accept.emit();
                this.modal.dismiss('accept');
            })
                .catch(error => console.error(error));
        }
    }
    onRejectCapacitacion() {
        this.capacitacionService.reject(this.capacitacion.capacitacionId, sessionStorage.getItem('userid'), this.actionOption, this.actionComment)
            .then(response => {
            this.reject.emit();
            this.modal.dismiss('reject');
        })
            .catch(error => console.error(error));
    }
    openAcceptModal(modal) {
        if (this.validationService.canAcceptOrReject(this.capacitacion, String(this.rolid)) || this.validationService.canClose(this.capacitacion, String(this.rolid))) {
            this.confirmationModalHasComment = true;
            this.confirmationModalHasOptions = false;
            this.confirmationModalisCommentObligatory = false;
            if (this.validationService.canAcceptOrReject(this.capacitacion, String(this.rolid))) {
                this.confirmationModalTittle = 'Aprobar capacitación';
                this.confirmationModalMessage = `¿Seguro que desea aprobar la capacitación "${this.capacitacion.name}"?`;
            }
            else {
                if (((this.capacitacion.realHours || 0) > 0 &&
                    (this.canAssignWorkers() && (this.capacitacion.realAssistants || 0)) > 0 &&
                    this.evidences.length > 0 &&
                    this.capacitacion.realExecutionDate)
                    || this.capacitacion.capacitacionTypeId == 2) {
                    this.confirmationModalTittle = 'Cerrar capacitación';
                    this.confirmationModalMessage = `¿Seguro que desea cerrar la capacitación "${this.capacitacion.name}"?`;
                    this.confirmationModalHasComment = true;
                }
                else {
                    this.toastr.info('Se debe actualizar : Duración Real , Asistentes Reales, Archivos de evidencia y Fecha Ejecución Real antes de cerrar', 'Advertencia');
                    return;
                }
                // this.confirmationModalTittle = 'Cerrar capacitación';
                // this.confirmationModalMessage = `¿Seguro que desea cerrar la capacitación "${this.capacitacion.name}"?`;
            }
            this.confirmationModalAccept = (comment, option) => {
                this.actionComment = comment;
                this.actionOption = option;
                this.onAcceptCapacitacion();
            };
            this.openModal(modal);
        }
    }
    openRejectModal(modal) {
        if (this.validationService.canAcceptOrReject(this.capacitacion, String(this.rolid))) {
            this.confirmationModalHasComment = true;
            this.confirmationModalHasOptions = true;
            this.confirmationModalTittle = 'Rechazar capacitación';
            this.confirmationModalMessage = `¿Seguro que desea rechazar la capacitación "${this.capacitacion.name}"?`;
            this.confirmationModalAccept = (comment, option) => {
                this.actionComment = comment;
                this.actionOption = option;
                this.onRejectCapacitacion();
            };
            this.openModal(modal);
        }
    }
    openSendForAcceptanceModal(modal) {
        if (this.validationService.canSendForAcceptance(this.capacitacion, String(this.rolid))) {
            this.confirmationModalHasComment = false;
            this.confirmationModalHasOptions = false;
            this.confirmationModalTittle = 'Enviar para aprobación';
            this.confirmationModalMessage = `¿Seguro que desea enviar para aprobación la capacitación "${this.capacitacion.name}"?`;
            this.confirmationModalAccept = () => this.onAcceptCapacitacion(true);
            this.openModal(modal);
        }
    }
    saveAndSend(modal) {
        this.onSave(true);
    }
    openPronexoModal(modal) {
        this.openModal(modal, { size: 'lg' });
    }
    openModal(modal, options = {}) {
        this.modalService.open(modal, Object.assign({ ariaLabelledBy: 'modal-basic-title' }, options));
    }
    changeInput(field, value, type = '') {
        if (field === 'categoryId') {
            const categoryId = parseInt(value, 10);
            this.capacitacion.categoryId = categoryId;
            this.focoCombo = this.getFocos(categoryId);
            this.capacitacion.focoId = this.focoCombo[0].focoId;
        }
        else if (field === 'year') {
            this.capacitacion.year = value;
        }
        else if (field === 'ejecutorId') {
            const ejecutorId = parseInt(value, 10);
            this.capacitacion.ejecutorId = ejecutorId;
            this.capacitacion.ejecutorOthers = null;
            this.capacitacion.relatorId = -1;
            this.relatorCombo = this.getRelatores(ejecutorId);
        }
        else if (field === 'zoneId') {
            const zoneId = parseInt(value, 10);
            this.capacitacion.zone = zoneId.toString();
        }
        else if (type === 'number') {
            this.capacitacion[field] = parseFloat(value);
        }
        else {
            this.capacitacion[field] = value;
        }
    }
    getFocos(categoryId) {
        let focos = [];
        for (const category of this.categoriesWithFocos) {
            if (category.categoryId === categoryId) {
                focos = category.focos;
                break;
            }
        }
        return focos;
    }
    getRelatores(ejecutorId) {
        let relatores = [];
        for (const ejecutor of this.ejecutoresWithRelatores) {
            if (ejecutor.ejecutorId === ejecutorId) {
                relatores = ejecutor.relatores;
                break;
            }
        }
        return relatores;
    }
    getTotalHours(value1, value2) {
        const firstValue = isNaN(value1) ? 0 : value1;
        const secondValue = isNaN(value2) ? 0 : value2;
        return firstValue + secondValue;
    }
    onWorkersSelectedChange(workersIdSelected, workersSelected) {
        this.workersIdSelected = workersIdSelected;
        this.workersSelected = workersSelected;
        this.workersRows = workersSelected.map(worker => this.buildWokerRow(worker));
        this.capacitacion.realAssistants = this.workersRows.length;
    }
    buildWokerRow(worker) {
        return {
            id: worker.rutTrabajador,
            worker,
            cells: [
                { class: 'td-centered', tooltip: false, content: worker.rutTrabajador },
                { class: 'td-centered', tooltip: false, content: worker.nombreTrabajador },
                { class: 'td-centered', tooltip: false, content: worker.apellidoPaterno },
                { class: 'td-centered', tooltip: false, content: worker.apellidoMaterno }
            ]
        };
    }
    canEditOnApprove() {
        if (this.validationService.isActiveEditOnApprove(this.capacitacion, String(this.rolid)) && (this.mode == 'edit')) {
            this.isRead = true;
            this.flags.AsignacionParticipantes = true;
            this.flags.Evidencia = true;
            this.flags.duracionPractica = true;
            this.flags.duracionTeorica = true;
            this.flags.duracionReal = true;
            this.flags.ejecutor = true;
            this.flags.fechaEjecucionReal = true;
            this.flags.relator = true;
            this.flags.Guardar = true;
        }
    }
    removeWorker(worker) {
        const idIndex = this.workersIdSelected.findIndex(id => id === worker.rutTrabajador);
        const workerIndex = this.workersSelected.findIndex(workerToAdd => workerToAdd.rutTrabajador === worker.rutTrabajador);
        const rowIndex = this.workersRows.findIndex(row => row.id === worker.rutTrabajador);
        this.workersIdSelected.splice(idIndex, 1);
        this.workersSelected.splice(workerIndex, 1);
        this.workersRows.splice(rowIndex, 1);
        this.capacitacion.realAssistants = this.workersRows.length;
    }
    updateWorker() {
        this.workersRows.map(worker => {
            if (!this.workersIdSelected.includes(worker.id))
                this.workersIdSelected.push(worker.id);
        });
    }
    onUpdateCapacitacion() {
        $("#btnEditCapacitacion").prop("disabled", true);
        $("#spanLoadEditar").css({ "display": "block" });
        console.log("Edicion Estado Actual Orden");
        console.log(this.capacitacion.stateShortDescription);
        this.showErrorMessage = false;
        this.showEvidenceMessage = false;
        this.updateWorker();
        this.capacitacion.isClosed = this.statusCloseCapacitacion.includes(this.capacitacion.statusCapacitacionLabel);
        let estimatedTrainingDateArray = this.capacitacion.estimatedTrainingDate.split('-');
        this.capacitacion.day = estimatedTrainingDateArray[0];
        this.capacitacion.month = estimatedTrainingDateArray[1];
        this.capacitacion.year = estimatedTrainingDateArray[2];
        console.log('------------------- INICIO REAL EXECUTION DATE -------------------');
        console.log(this.capacitacion.realExecutionDate);
        if (this.capacitacion.realExecutionDate != undefined && this.capacitacion.realExecutionDate != '' && this.capacitacion.realExecutionDate != null) {
            let executionDateArray = this.capacitacion.realExecutionDate.split('-');
            this.capacitacion.realExecutionDate = executionDateArray[0].padStart(2, '0') + '-' + executionDateArray[1].padStart(2, '0') + '-' + executionDateArray[2].padStart(2, '0');
        }
        if (this.capacitacion.capacitacionTypeId == 2) {
            this.capacitacion.realExecutionDate = estimatedTrainingDateArray[0].padStart(2, '0') + '-' + estimatedTrainingDateArray[1].padStart(2, '0') + '-' + estimatedTrainingDateArray[2].padStart(2, '0');
        }
        console.log('------------------- FIN REAL EXECUTION DATE -------------------');
        this.capacitacionService.update(this.capacitacion, this.capacitacion.capacitacionId, this.workersIdSelected)
            .then(response => {
            $("#btnEditCapacitacion").prop("disabled", false);
            $("#spanLoadEditar").css({ "display": "none" });
            this.save.emit();
            this.modal.dismiss('saved');
        })
            .catch(error => {
            console.log('Error en la actualizacion de la capacitacion');
            console.log(error);
            $("#btnEditCapacitacion").prop("disabled", false);
            $("#spanLoadEditar").css({ "display": "none" });
            this.showErrorMessage = true;
            this.showEvidenceMessage = true;
        });
    }
    onSave(send = false) {
        this.showErrorMessage = false;
        this.showEvidenceMessage = false;
        this.capacitacion.creationDate = this.capacitacion.estimatedTrainingDate;
        if (this.isValid()) {
            this.closeCapacitacionStatus = true;
            if (this.mode === 'edit') {
                $("#btnCloseCapacitacion").prop("disabled", true);
                console.log("entro acá");
                this.updateWorker();
                this.capacitacion.isClosed = true;
                let estimatedTrainingDateArray = this.capacitacion.estimatedTrainingDate.split('-');
                this.capacitacion.day = estimatedTrainingDateArray[0];
                this.capacitacion.month = estimatedTrainingDateArray[1];
                this.capacitacion.year = estimatedTrainingDateArray[2];
                let executionDateArray = this.capacitacion.realExecutionDate.split('-');
                this.capacitacion.realExecutionDate = executionDateArray[2].padStart(2, '0') + '-' + executionDateArray[1].padStart(2, '0') + '-' + executionDateArray[0];
                console.log(this.capacitacion.realExecutionDate);
                this.capacitacionService.update(this.capacitacion, this.capacitacion.capacitacionId, this.workersIdSelected)
                    .then(response => {
                    if (send) {
                        this.onAcceptCapacitacion();
                    }
                    else {
                        this.save.emit();
                        this.modal.dismiss('saved');
                    }
                })
                    .catch(error => {
                    $("#btnCloseCapacitacion").prop("disabled", false);
                    this.closeCapacitacionStatus = false;
                    console.log("primer error");
                    console.error(error);
                    this.showErrorMessage = true;
                    this.showEvidenceMessage = true;
                });
            }
            else {
                $("#btnCloseCapacitacion").prop("disabled", true);
                console.log("paso por acá");
                console.log(this.capacitacion, this.workersIdSelected);
                this.capacitacionService.create(this.capacitacion, this.workersIdSelected)
                    .then(response => {
                    this.capacitacion.capacitacionId = Number(response);
                    if (send) {
                        this.onAcceptCapacitacion();
                    }
                    else {
                        this.save.emit();
                        this.modal.dismiss('created');
                    }
                    this.saveEvidence();
                    $("#btnCloseCapacitacion").prop("disabled", false);
                    this.closeCapacitacionStatus = false;
                })
                    .catch(error => {
                    $("#btnCloseCapacitacion").prop("disabled", false);
                    this.closeCapacitacionStatus = false;
                    console.log("error final");
                    this.showErrorMessage = true;
                    console.error(error);
                });
            }
        }
    }
    isValid() {
        let isValid = true;
        const isNameValid = this.capacitacion.name && this.capacitacion.name.length <= 999;
        isValid = isValid ? isNameValid : false;
        this.errors.name = !isNameValid;
        const isCategoryIdValid = this.capacitacion.categoryId !== -1;
        isValid = isValid ? isCategoryIdValid : false;
        this.errors.categoryId = !isCategoryIdValid;
        const isFocoIdValid = this.capacitacion.focoId !== -1;
        isValid = isValid ? isFocoIdValid : false;
        this.errors.focoId = !isFocoIdValid;
        const isEnfoqueValid = this.capacitacion.enfoqueId !== -1;
        isValid = isValid ? isEnfoqueValid : false;
        this.errors.enfoqueId = !isEnfoqueValid;
        const isEjecutorIdValid = this.capacitacion.ejecutorId !== -1;
        isValid = isValid ? isEjecutorIdValid : false;
        this.errors.ejecutorId = !isEjecutorIdValid;
        if (this.capacitacion.ejecutorId == 4) {
            if (this.capacitacion.ejecutorOthers == null || this.capacitacion.ejecutorOthers == '') {
                const isEjecutorOthersValid = false;
                isValid = isValid ? isEjecutorOthersValid : false;
                this.errors.ejecutorOthers = !isEjecutorOthersValid;
            }
            else {
                const isEjecutorOthersValid = this.capacitacion.ejecutorOthers.substring(0, 1) != ' ';
                isValid = isValid ? isEjecutorOthersValid : false;
                this.errors.ejecutorOthers = !isEjecutorOthersValid;
            }
        }
        else {
            const isEjecutorOthersValid = this.capacitacion.ejecutorOthers == null || this.capacitacion.ejecutorOthers.length <= 100;
            isValid = isValid ? isEjecutorOthersValid : false;
            this.errors.ejecutorOthers = !isEjecutorOthersValid;
        }
        const isRelatorIdValid = this.capacitacion.relatorId !== -1;
        isValid = isValid ? isRelatorIdValid : false;
        this.errors.relatorId = !isRelatorIdValid;
        const isRealHoursValid = this.capacitacion.realHours > 0 && this.capacitacion.realHours >= 0.5;
        isValid = isValid ? isRealHoursValid : false;
        this.errors.realHours = !isRealHoursValid;
        const isEstimatedAssistantsValid = this.capacitacion.capacitacionTypeId === REFORZAMIENTO_ID || (this.capacitacion.capacitacionTypeId === PLANIFICADA_ID && this.capacitacion.estimatedAssistants !== null && (0 < this.capacitacion.estimatedAssistants && this.capacitacion.estimatedAssistants.toString().length <= 4));
        isValid = isValid ? isEstimatedAssistantsValid : false;
        this.errors.estimatedAssistants = !isEstimatedAssistantsValid;
        //al guardar en modo editar no debe validar, solo guardar los cambios ::TODO
        if (this.mode != 'edit') {
            if (this.capacitacion.stateId == CERRADA_STATE || this.capacitacion.stateId == APROBADA_STATE
                || this.capacitacion.stateId == PENDIENTE_STATE || this.capacitacion.stateId == PENDIENTE_CON_RETRASO_STATE) {
                const isRealAssistantsValid = this.capacitacion.capacitacionTypeId == REFORZAMIENTO_ID || (this.capacitacion.realAssistants == null || (this.capacitacion.realAssistants > 0 && this.capacitacion.realAssistants.toString().length <= 4));
                isValid = isValid ? isRealAssistantsValid : false;
                this.errors.realAssistants = !isRealAssistantsValid;
                const cantidadEvidencias = this.capacitacion.capacitacionTypeId == REFORZAMIENTO_ID || this.listClass;
                isValid = isValid ? cantidadEvidencias : false;
                this.errors.realEvidence = !cantidadEvidencias;
            }
            // if (this.mode === 'reforzamiento') {
            // 	if(this.evidences.length === 0){
            // 		this.errors.realEvidence = true
            // 		isValid = false
            // 	}else{
            // 		this.errors.realEvidence = false
            // 	}
            // }
        }
        // if (this.mode === 'reforzamiento') {
        // 	if(this.capacitacion.realAssistants === 0){
        // 		this.errors.realAssistants = true
        // 		isValid = false
        // 	}else{
        // 		this.errors.realAssistants = false
        // 	}
        // }
        if (this.capacitacion.realAssistants === 0) {
            this.errors.realAssistants = true;
            isValid = false;
        }
        else {
            this.errors.realAssistants = false;
        }
        if (this.evidences.length === 0) {
            this.errors.realEvidence = true;
            isValid = false;
        }
        else {
            this.errors.realEvidence = false;
        }
        const isRealExecutionDateValid = this.capacitacion.realExecutionDate == null || this.isValidExecutionDate(this.capacitacion.realExecutionDate);
        isValid = isValid ? isRealExecutionDateValid : false;
        this.errors.realExecutionDate = !isRealExecutionDateValid;
        const isObservationValid = !this.capacitacion.observation || this.capacitacion.observation.length < 500;
        isValid = isValid ? isObservationValid : false;
        this.errors.observation = !isObservationValid;
        const isZonaValid = this.capacitacion.zone != '-1';
        isValid = isValid ? isZonaValid : false;
        this.errors.zoneId = !isZonaValid;
        console.log('Validando Fecha de Capacitacion');
        console.log(this.capacitacion.creationDate);
        const isFechaValid = this.capacitacion.creationDate != null;
        isValid = isValid ? isFechaValid : false;
        this.errors.fechaCapacitacion = !isFechaValid;
        if (isFechaValid) {
            this.capacitacion.fecha = String(this.capacitacion.creationDate);
        }
        return isValid;
    }
    isValidExecutionDate(value) {
        // if(value.includes(/-/g))
        // value = value.replace(/-/g,'/')
        console.log('Console Is Valid Execution Date');
        console.log(value);
        let date = moment(value, 'DD-MM-YYYY').format('YYYY-MM-DD');
        console.log('Date Formateada');
        console.log(date);
        this.capacitacion.realExecutionDate = date;
        return true;
    }
    isValidDateFormat(parts) {
        return parts.length === 3 && parts[0].length === 2 && (parts[1].length === 2 || parts[1].length == 1) && parts[2].length === 4;
    }
    isValidDate(parts) {
        return parts.length === 3 && parts[0].length === 2 && (parts[1].length === 2 || parts[1].length == 1) && parts[2].length === 4;
    }
    getMonthLabel(id) {
        return MONTHS[id - 1].label;
    }
    getZonas() {
        return new Promise((resolve, reject) => {
            this.zoneService.getZonas()
                .then(response => {
                this.zonas = response;
                if (this.zonas.length == 1) {
                    this.flagZona = true;
                    this.capacitacion.zone = this.zonas[0].zoneId.toString();
                }
            })
                .catch(error => reject(error));
        });
    }
    getZoneLabel(id) {
        let descripcion;
        this.zonas.forEach(element => {
            if (element.zoneId == id) {
                descripcion = element.descripcion;
            }
        });
        return descripcion;
    }
    fetchEvidencia() {
        if (this.capacitacion.capacitacionId) {
            this.evidenciaService.list(this.uuid ? this.uuid : this.capacitacion.capacitacionId)
                .then(evidencias => {
                this.evidences = evidencias.evidencias;
                if (this.evidences.length > 0) {
                    //this.messageFieldUpload = "Archivo cargado con éxito"
                    this.listClass = true;
                    this.fileUpload = false;
                }
            })
                .catch(error => {
                this.fileUpload = false;
                console.error(error);
            });
        }
    }
    fetchEvidenciaTemp() {
        this.evidenciaService.listTemp(this.uuid ? this.uuid : this.capacitacion.capacitacionId)
            .then(evidencias => {
            this.evidences = evidencias.evidencias;
            if (this.evidences.length > 0) {
                //this.messageFieldUpload = "Archivo cargado con éxito"
                this.listClass = true;
            }
            this.fileUpload = false;
        })
            .catch(error => {
            this.fileUpload = false;
            console.error(error);
        });
    }
    deleteFile(id) {
        this.evidenciaService.delete(id).then(res => {
            this.fetchEvidencia();
            this.fetchEvidenciaTemp();
        })
            .catch(error => console.error(error));
    }
    downloadFile(id, name) {
        this.evidenciaService.downloadFile(id, name);
    }
    // readFileAsArrayBuffer(file: File): Promise<ArrayBuffer> {
    // 	return new Promise((resolve, reject) => {
    // 	  const reader = new FileReader();
    // 	  reader.onload = () => {
    // 		const buffer = reader.result as ArrayBuffer;
    // 		resolve(buffer);
    // 	  };
    // 	  reader.onerror = () => {
    // 		reject(new Error('Error al leer el archivo'));
    // 	  };
    // 	  reader.readAsArrayBuffer(file);
    // 	});
    //   }
    //   async validateFile(file: File) {
    // 	const buffer =  await this.readFileAsArrayBuffer(file);
    // 	const fileType =  await FileType.fileTypeFromBuffer(buffer);
    // 	if (!this.arrayTypeFile.includes(fileType.mime)) {
    // 		this.error = true;
    // 		this.errorMessage = 'Tipo de archivo no válido.'
    // 		return;
    // 	} 
    //   }
    uploadFile(event, formDirective, archivo) {
        console.log(event);
        console.log(formDirective);
        console.log(archivo);
        const file = event.target.files[0];
        this.form.patchValue({
            evidenceFile: file
        });
        this.form.get('evidenceFile').updateValueAndValidity();
        console.log(file);
        //this.validateFile(file);
        let isMimeTypeValid = this.arrayTypeFile.includes(file.type);
        console.log('isMimeTypeValid', isMimeTypeValid);
        if (!isMimeTypeValid) {
            this.error = true;
            this.errorMessage = 'Tipo de archivo no válido.';
            return;
        }
        if (this.form.value.evidenceFile != null) {
            this.messageFieldUpload = "Cargando archivo ....";
            const formData = new FormData();
            formData.append('file', this.form.value.evidenceFile, this.form.value.evidenceFile.name);
            formDirective.resetForm();
            this.form.reset();
            let cap = 0;
            try {
                cap = this.capacitacion.capacitacionId;
            }
            catch (error) {
                console.log("error cap: " + error);
            }
            if (cap != 0 && cap != null) {
                this.fileUpload = true;
                this.evidenciaService.upload(this.capacitacion.capacitacionId, formData).then((data) => {
                    this.fetchEvidencia();
                }).catch((error) => {
                    this.fileUpload = false;
                    this.messageFieldUpload = "";
                    this.errorMessage = error.error.message.includes("Maximum upload size exceeded") ? 'Error al guardar, archivo excede el límite definido.' : 'Error';
                });
            }
            else {
                this.fileUpload = true;
                this.evidenciaService.uploadTemp(this.uuid == "" ? null : this.uuid, formData).then((data) => {
                    this.messageFieldUpload = "Cargando archivo ....";
                    this.uuid = data.resultado;
                    //this.fetchEvidencia();
                    this.fetchEvidenciaTemp();
                }).catch((error) => {
                    this.fileUpload = false;
                    this.messageFieldUpload = "";
                    this.errorMessage = error.error.message.includes("Maximum upload size exceeded") ? 'Error al guardar, archivo excede el límite definido.' : 'Error';
                });
            }
        }
        else {
            this.fileUpload = false;
            this.messageFieldUpload = "";
            this.error = true;
            this.errorMessage = 'Error al guardar, debe ingresar un archivo.';
        }
        archivo.value = "";
    }
    saveEvidence() {
        if (this.uuid != "") {
            this.evidenciaService.saveTemp(this.uuid, this.capacitacion.capacitacionId).then((data) => {
            }).catch((error) => {
                console.log(error);
            });
        }
    }
    calculeSvgIcon(file) {
        const fileExt = file.split(".");
        let svg = "";
        switch (fileExt[fileExt.length - 1]) {
            case "jpg":
                svg = 'assets/icons/jpg_format.svg';
                break;
            case "png":
                svg = 'assets/icons/png_format.svg';
                break;
            case "zip":
                svg = 'assets/icons/zip_format.svg';
                break;
            case "rar":
                svg = 'assets/icons/rar_format.svg';
                break;
            case "ppt":
                svg = 'assets/icons/ppt_format.svg';
                break;
            case "pptx":
                svg = 'assets/icons/ppt_format.svg';
                break;
            case "pdf":
                svg = 'assets/icons/pdf_format.svg';
                break;
            case "xls":
                svg = 'assets/icons/excel_black.svg';
                break;
            case "xlsx":
                svg = 'assets/icons/excel_black.svg';
                break;
            case "doc":
                svg = 'assets/icons/word.svg';
                break;
            case "docx":
                svg = 'assets/icons/word.svg';
                break;
            default:
                svg = 'assets/icons/text_format.svg';
                break;
        }
        return svg;
    }
    estadoCerrada() {
        if (this.capacitacion.stateId == 5) {
            return false;
        }
        else {
            return true;
        }
    }
    disabledInput() {
    }
}
